import React from 'react'

const StickyHours = () => {
  return (
    <>
      <div className="nav-prog sticky">
        <div className="col-hours">
          {
            [...Array(48).keys()].map((i) => {
              let number = parseInt(i / 2)
              number.toString().length === 1 && (number = `0${number}`)
              let hour = `${number}:00`
              i % 2 !== 0 && (hour = `${number}:30`)
            
              return (
                <div key={`col-hour-${i}`} className="col-hour">
                  <div className={`block-hour ${i === 47 ? 'noafter' : ''}`}>
                    <p>{hour}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  )
}

export default React.memo(StickyHours)
